import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Slovakia() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Slovakia') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [type, setType] = useState('');

    const [bName, setBName] = useState('');
    const [street, setStreet] = useState('');
    const [hNumber, setHnumber] = useState('');
    const [postal, setPostal] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [id, setId] = useState('');
    const [represented, setRepresented] = useState('');
    const [sTitle, setSTitle] = useState('');
    const [authorization, setAuthorization] = useState('');

    const [bName1, setBName1] = useState('');
    const [street1, setStreet1] = useState('');
    const [hNumber1, setHnumber1] = useState('');
    const [postal1, setPostal1] = useState('');
    const [city1, setCity1] = useState('');
    const [state1, setState1] = useState('');
    const [id1, setId1] = useState('');
    const [represented1, setRepresented1] = useState('');
    const [sTitle1, setSTitle1] = useState('');
    const [authorization1, setAuthorization1] = useState('');

    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [telNum, setTelNum] = useState('');

    const [fax, setFax] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');

    const [place, setPlace] = useState('');
    const [date, setDate] = useState('');
    const [sign, setSign] = useState('');

    // const [placeReci, setPlaceReci] = useState('');
    // const [dateReci, setDateReci] = useState('');
    // const [nameEmployee, setNameEmployee] = useState('');
    // const [signReci, setSignReci] = useState('');

    const [applicationType, setApplicationType] = useState('');
    const handleApplicationTypeChange = (value) => {
        setApplicationType(value);

        if (value === 'Simple (single number)') {
            setTableDataSingle(prev =>
                prev.length === 0
                    ? [{ id: Date.now(), num: '' }]
                    : prev
            );
        }

        if (value === 'Complex (MSN, DDI)') {
            setTableDataRange(prev =>
                prev.length === 0
                    ? [{ id: Date.now(), sNumber: '', eNumber: '' }]
                    : prev
            );
        }
    };

    const [recipient, setRecipient] = useState('');
    const [donor, setDonor] = useState('');
    const [datePort, setDatePort] = useState('');
    const [dateService, setDateService] = useState('');
    const [donorNumber, setDonorNumber] = useState('');

    const isSimple = applicationType === 'Simple (single number)';
    const isComplex = applicationType === 'Complex (MSN, DDI)';

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        const data = JSONDATA?.country?.operatorDetails;

        if (!data) return;

        // TYPE
        const selectedType = data?.Type ?? '';
        setType(selectedType);

        // SUBSCRIBER
        if (selectedType === 'Subscriber') {
            setBName(data?.BName ?? '');
            setStreet(data?.Street ?? '');
            setHnumber(data?.HNumber ?? '');
            setPostal(data?.Postal ?? '');
            setCity(data?.City ?? '');
            setState(data?.State ?? '');
            setId(data?.Id ?? '');
            setRepresented(data?.Represented ?? '');
            setSTitle(data?.STitle ?? '');
            setAuthorization(data?.Authorization ?? '');
        }

        // AUTHORIZED
        if (selectedType === 'Authorized') {
            setBName1(data?.BName1 ?? '');
            setStreet1(data?.Street1 ?? '');
            setHnumber1(data?.HNumber1 ?? '');
            setPostal1(data?.Postal1 ?? '');
            setCity1(data?.City1 ?? '');
            setState1(data?.State1 ?? '');
            setId1(data?.Id1 ?? '');
            setRepresented1(data?.Represented1 ?? '');
            setSTitle1(data?.STitle1 ?? '');
            setAuthorization1(data?.Authorization1 ?? '');
        }

        // COMMON FIELDS
        setName(data?.Name ?? '');
        setTitle(data?.Title ?? '');
        setTelNum(data?.TelNum ?? '');
        setFax(data?.Fax ?? '');
        setMobile(data?.Mobile ?? '');
        setEmail(data?.Email ?? '');

        setApplicationType(data?.ApplicationType ?? '');
        setTableDataSingle(data?.TableDataSingle ?? []);
        setTableDataRange(data?.TableDataRange ?? []);

        setRecipient(data?.Recipient ?? '');
        setDonor(data?.Donor ?? '');
        setDatePort(data?.DatePort ?? '');
        setDateService(data?.DateService ?? '');
        setDonorNumber(data?.DonorNumber ?? '');

        setPlace(data?.Place ?? '');
        setDate(data?.Date ?? '');
        setSign(data?.Sign ?? '');
        // setPlaceReci(data?.PlaceReci ?? '');
        // setDateReci(data?.DateReci ?? '');
        // setNameEmployee(data?.NameEmployee ?? '');
        // setSignReci(data?.SignReci ?? '');
    };

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^\d+$/.test(row.sNumber);
                const isEndValid = /^\d+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Slovakia",

            "operatorDetails": {
                Type: type,

                // Subscriber fields
                BName: type === "Subscriber" ? bName : '',
                Street: type === "Subscriber" ? street : '',
                HNumber: type === "Subscriber" ? hNumber : '',
                Postal: type === "Subscriber" ? postal : '',
                City: type === "Subscriber" ? city : '',
                State: type === "Subscriber" ? state : '',
                Id: type === "Subscriber" ? id : '',
                Represented: type === "Subscriber" ? represented : '',
                STitle: type === "Subscriber" ? sTitle : '',
                Authorization: type === "Subscriber" ? authorization : '',

                // Authorized fields
                BName1: type === "Authorized" ? bName1 : '',
                Street1: type === "Authorized" ? street1 : '',
                HNumber1: type === "Authorized" ? hNumber1 : '',
                Postal1: type === "Authorized" ? postal1 : '',
                City1: type === "Authorized" ? city1 : '',
                State1: type === "Authorized" ? state1 : '',
                Id1: type === "Authorized" ? id1 : '',
                Represented1: type === "Authorized" ? represented1 : '',
                STitle1: type === "Authorized" ? sTitle1 : '',
                Authorization1: type === "Authorized" ? authorization1 : '',

                "Name": name,
                "Title": title,
                "TelNum": telNum,
                "Fax": fax,
                "Mobile": mobile,
                "Email": email,

                "ApplicationType": applicationType,

                "TableDataSingle": applicationType === "Simple (single number)"
                    ? tableDataSingle
                    : [],

                "TableDataRange": applicationType === "Complex (MSN, DDI)"
                    ? tableDataRange
                    : [],

                "Recipient": recipient,
                "Donor": donor,
                "DatePort": datePort,
                "DateService": dateService,
                "DonorNumber": donorNumber,
                "Place": place,
                "Date": date,
                "Sign": sign
                // "PlaceReci": placeReci,
                // "DateReci": dateReci,
                // "NameEmployee": nameEmployee,
                // "SignReci": signReci
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        let validationErrors = {};

        if (!type) {
            validationErrors.type = 'Please select type';
        }

        if (type === 'Subscriber') {
            if (!bName) {
                validationErrors.bName = 'Please fill in Business name (or surname, name and academic degree):';
            }
            if (!street) {
                validationErrors.street = 'Please fill in Registered seat - street';
            }
            if (!hNumber) {
                validationErrors.hNumber = 'Please fill in Registered seat - house number';
            }
            if (!postal) {
                validationErrors.postal = 'Please fill in Registered seat - postal code';
            }
            if (!city) {
                validationErrors.city = 'Please fill in Registered seat - city';
            }
            if (!id) {
                validationErrors.id = 'Please fill in ID No: (Business registration Number)';
            }
            if (!authorization) {
                validationErrors.authorization = 'Please fill in Authorization';
            }
        }

        if (type === 'Authorized') {
            if (!bName1) {
                validationErrors.bName1 = 'Please fill in Business name (or surname, name and academic degree):';
            }
            if (!street1) {
                validationErrors.street1 = 'Please fill in Registered seat - street';
            }
            if (!hNumber1) {
                validationErrors.hNumber1 = 'Please fill in Registered seat - house number';
            }
            if (!postal1) {
                validationErrors.postal1 = 'Please fill in Registered seat - postal code';
            }
            if (!city1) {
                validationErrors.city1 = 'Please fill in Registered seat - city';
            }
            if (!id1) {
                validationErrors.id1 = 'Please fill in ID No: (Business registration Number)';
            }
            if (!authorization1) {
                validationErrors.authorization1 = 'Please fill in Authorization';
            }
        }

        if (!name) {
            validationErrors.name = 'Please fill in Name, Surname';
        }
        if (!title) {
            validationErrors.title = 'Please fill in Title';
        }
        if (!telNum) {
            validationErrors.telNum = 'Please fill in Telephone';
        }
        if (!email) {
            validationErrors.email = 'Please fill in Email';
        }

        if (isSimple) {
            tableDataSingle.forEach(row => {
                if (!row.num) {
                    validationErrors[`number-${row.id}`] = 'Single Number is required.';
                } else if (!/^\d+$/.test(row.num)) {
                    validationErrors[`number-${row.id}`] = 'Single Number must contain only digits.';
                }
            });
        }

        if (isComplex) {
            tableDataRange.forEach(row => {
                if (!row.sNumber) {
                    validationErrors[`startNumber-${row.id}`] = 'Start number is required.';
                } else if (!/^\d+$/.test(row.sNumber)) {
                    validationErrors[`startNumber-${row.id}`] = 'Start number must be numeric.';
                }

                if (!row.eNumber) {
                    validationErrors[`endNumber-${row.id}`] = 'End number is required.';
                } else if (!/^\d+$/.test(row.eNumber)) {
                    validationErrors[`endNumber-${row.id}`] = 'End number must be numeric.';
                }
            });
        }

        if (!recipient) {
            validationErrors.recipient = 'Please fill in the recipient';
        }
        if (!donor) {
            validationErrors.donor = 'Please fill in the Donor';
        }
        if (!donorNumber) {
            validationErrors.donorNumber = 'Please fill in the Donor';
        }
        if (!place) {
            validationErrors.place = 'Please fill in Place';
        }
        if (!date) {
            validationErrors.date = 'Please fill in Date';
        }
        if (!sign) {
            validationErrors.sign = 'Please fill in Signature and stamp of the applicant (or authorised person or legal guardian)';
        }
        // if (!dateReci) {
        //     validationErrors.dateReci = 'Please fill in Date of receiving the Application';
        // }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = name + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();

        if (applicationType === 'Simple (single number)') {
            // clear complex AFTER saving simple
            setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
        }

        if (applicationType === 'Complex (MSN, DDI)') {
            // clear simple AFTER saving complex
            setTableDataSingle([{ id: Date.now(), num: '' }]);
        }
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <p>The company is incorporated in the Commercial Register of District Court Bratislava I, section: Sro, insert No: 81658/B, ID No: 35795662</p>

                <br></br>

                <Row>
                    <Col>
                        <label>Type*</label><br />
                        <select
                            id="type"
                            value={type}
                            onChange={(e) => {
                                setType(e.target.value);
                                setValidationStates({});
                            }}
                            className={`inputbox ${validationStates.type === false ? 'error' : ''}`}
                            onBlur={() => validateInput('type', /^.*$/)}
                        >
                            <option value="">Choose One</option>
                            <option value="Subscriber">Subscriber</option>
                            <option value="Authorized">Authorised Person / Legal Guardian</option>
                        </select>
                    </Col>
                </Row>

                <br />

                {/* SUBSCRIBER */}
                {type === "Subscriber" && (
                    <Container>

                        <h2 className='heading'>Subscriber</h2> <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('bName')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Business name (or surname, name and academic degree)*</label> <br />
                                <input
                                    onChange={(e) => setBName(e.target.value)}
                                    type="text"
                                    id="bName"
                                    value={bName}
                                    className={`inputbox ${validationStates.bName === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('bName', /^[A-Za-z\s]+$/)}
                                />
                                {hoveredField === 'bName' && (
                                    <div className="hover-description">
                                        Enter name/surname.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('street')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - street*</label> <br />
                                <input
                                    onChange={(e) => setStreet(e.target.value)}
                                    type="text"
                                    id="street"
                                    value={street}
                                    className={`inputbox ${validationStates.street === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('street', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'street' && (
                                    <div className="hover-description">
                                        Enter street.
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('hNumber')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - house number*</label> <br />
                                <input
                                    onChange={(e) => setHnumber(e.target.value)}
                                    type="text"
                                    id="hNumber"
                                    value={hNumber}
                                    className={`inputbox ${validationStates.hNumber === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('hNumber', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'hNumber' && (
                                    <div className="hover-description">
                                        Enter house number.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('postal')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - postal code*</label> <br />
                                <input
                                    onChange={(e) => setPostal(e.target.value)}
                                    type="text"
                                    id="postal"
                                    value={postal}
                                    className={`inputbox ${validationStates.postal === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('postal', /^.*$/)}
                                />
                                {hoveredField === 'postal' && (
                                    <div className="hover-description">
                                        Enter code.
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('city')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - city*</label> <br />
                                <input
                                    onChange={(e) => setCity(e.target.value)}
                                    type="text"
                                    id="city"
                                    value={city}
                                    className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('city', /^[a-zA-Z\s]+$/)}
                                />
                                {hoveredField === 'city' && (
                                    <div className="hover-description">
                                        Enter city.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('state')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - state</label> <br />
                                <input
                                    onChange={(e) => setState(e.target.value)}
                                    type="text"
                                    id="state"
                                    value={state}
                                    placeholder=""
                                    className={`inputbox ${validationStates.state === false ? 'error' : ''}`}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        const isValid = value === '' || /^[A-Za-z\s]+$/u.test(value);
                                        setValidationStates(prev => ({ ...prev, state: isValid }));

                                        if (value !== '' && !isValid) {
                                            toast.error(
                                                'Only Alphabetical values are allowed.'
                                            );
                                        }
                                    }}
                                />
                                {hoveredField === 'state' && (
                                    <div className="hover-description">
                                        Enter state.
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('id')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>ID No: (Business registration Number)*</label> <br />
                                <input
                                    onChange={(e) => setId(e.target.value)}
                                    type="text"
                                    id="id"
                                    value={id}
                                    className={`inputbox ${validationStates.id === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('id', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'id' && (
                                    <div className="hover-description">
                                        Business registration number.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('represented')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Represented By</label> <br />
                                <input
                                    onChange={(e) => setRepresented(e.target.value)}
                                    type="text"
                                    id="represented"
                                    value={represented}
                                    className={`inputbox`}
                                />
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('sTitle')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Title</label> <br />
                                <input
                                    onChange={(e) => setSTitle(e.target.value)}
                                    type="text"
                                    id="sTitle"
                                    value={sTitle}
                                    className={`inputbox`}
                                />
                                {hoveredField === 'sTitle' && (
                                    <div className="hover-description">
                                        Enter person's position.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('authorization')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Authorization*</label> <br />
                                <input
                                    onChange={(e) => setAuthorization(e.target.value)}
                                    type="text"
                                    id="authorization"
                                    value={authorization}
                                    className={`inputbox ${validationStates.authorization === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('authorization', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'authorization' && (
                                    <div className="hover-description">
                                        Enter Authorized name.
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </Container>
                )}

                {/* AUTHORIZED */}
                {type === "Authorized" && (
                    <Container>

                        <h2 className='heading'>Authorised person or legal guardian</h2> <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('bName1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Business name (or surname, name and academic degree)*</label> <br />
                                <input
                                    onChange={(e) => setBName1(e.target.value)}
                                    type="text"
                                    id="bName1"
                                    value={bName1}
                                    className={`inputbox ${validationStates.bName1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('bName1', /^[A-Za-z\s]+$/)}
                                />
                                {hoveredField === 'bName1' && (
                                    <div className="hover-description">
                                        Enter name/surname.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('street1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - street*</label> <br />
                                <input
                                    onChange={(e) => setStreet1(e.target.value)}
                                    type="text"
                                    id="street1"
                                    value={street1}
                                    className={`inputbox ${validationStates.street1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('street1', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'street1' && (
                                    <div className="hover-description">
                                        Enter street.
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('hNumber1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - house number*</label> <br />
                                <input
                                    onChange={(e) => setHnumber1(e.target.value)}
                                    type="text"
                                    id="hNumber1"
                                    value={hNumber1}
                                    className={`inputbox ${validationStates.hNumber1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('hNumber1', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'hNumber1' && (
                                    <div className="hover-description">
                                        Enter house number.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('postal1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - postal code*</label> <br />
                                <input
                                    onChange={(e) => setPostal1(e.target.value)}
                                    type="text"
                                    id="postal1"
                                    value={postal1}
                                    className={`inputbox ${validationStates.postal === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('postal1', /^.*$/)}
                                />
                                {hoveredField === 'postal1' && (
                                    <div className="hover-description">
                                        Enter code.
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('city1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - city*</label> <br />
                                <input
                                    onChange={(e) => setCity1(e.target.value)}
                                    type="text"
                                    id="city1"
                                    value={city1}
                                    className={`inputbox ${validationStates.city1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('city1', /^[a-zA-Z\s]+$/)}
                                />
                                {hoveredField === 'city1' && (
                                    <div className="hover-description">
                                        Enter city.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('state1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Registered seat - state</label> <br />
                                <input
                                    onChange={(e) => setState1(e.target.value)}
                                    type="text"
                                    id="state1"
                                    value={state1}
                                    placeholder=""
                                    className={`inputbox ${validationStates.state1 === false ? 'error' : ''}`}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        const isValid = value === '' || /^[A-Za-z\s]+$/u.test(value);
                                        setValidationStates(prev => ({ ...prev, state1: isValid }));

                                        if (value !== '' && !isValid) {
                                            toast.error(
                                                'Only Alphabetical values are allowed.'
                                            );
                                        }
                                    }}
                                />
                                {hoveredField === 'state1' && (
                                    <div className="hover-description">
                                        Enter state.
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('id1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>ID No: (Business registration Number)*</label> <br />
                                <input
                                    onChange={(e) => setId1(e.target.value)}
                                    type="text"
                                    id="id1"
                                    value={id1}
                                    className={`inputbox ${validationStates.id1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('id1', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'id1' && (
                                    <div className="hover-description">
                                        Enter ID.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('represented1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Represented By</label> <br />
                                <input
                                    onChange={(e) => setRepresented1(e.target.value)}
                                    type="text"
                                    id="represented1"
                                    value={represented1}
                                    className={`inputbox`}
                                />
                            </Col>

                        </Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('sTitle1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Title</label> <br />
                                <input
                                    onChange={(e) => setSTitle1(e.target.value)}
                                    type="text"
                                    id="sTitle1"
                                    value={sTitle1}
                                    className={`inputbox`}
                                />
                                {hoveredField === 'bName1' && (
                                    <div className="hover-description">
                                        Enter person's position.
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('authorization1')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Authorization*</label> <br />
                                <input
                                    onChange={(e) => setAuthorization1(e.target.value)}
                                    type="text"
                                    id="authorization1"
                                    value={authorization1}
                                    className={`inputbox ${validationStates.authorization1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('authorization1', /^[A-Za-z0-9\s]+$/)}
                                />
                                {hoveredField === 'bName1' && (
                                    <div className="hover-description">
                                        Enter Authorized name.
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </Container>
                )}

                <br />

                <Container>

                    <p className='heading'>Important note  :: (*) to be filled in only if the application is submitted by a person other than the Subscriber.</p>

                    <h2 className='heading'>Contact</h2> <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Name, Surname*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id='name'
                                value={name}
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter name/surname.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('title')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Title*</label>
                            <input
                                onChange={(e) => setTitle(e.target.value)}
                                type="text"
                                id="title"
                                value={title}
                                placeholder=""
                                className={`inputbox ${validationStates.title === false ? 'error' : ''}`}
                                onBlur={() => validateInput('title', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'title' && (
                                <div className="hover-description">
                                    Enter person's position.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('telNum')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Telephone*</label>
                            <input
                                onChange={(e) => setTelNum(e.target.value)}
                                type="text"
                                id="telNum"
                                value={telNum}
                                placeholder=""
                                className={`inputbox ${validationStates.telNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('telNum', /^\d+$/)}
                            />
                            {hoveredField === 'telNum' && (
                                <div className="hover-description">
                                    Enter phone number.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('fax')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Fax</label>
                            <input
                                onChange={(e) => setFax(e.target.value)}
                                type="text"
                                id="fax"
                                value={fax}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'fax' && (
                                <div className="hover-description">
                                    Fax number.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Mobile</label> <br />
                            <input
                                onChange={(e) => setMobile(e.target.value)}
                                type="text"
                                id="mobile"
                                value={mobile}
                                placeholder=""
                                className={`inputbox ${validationStates.mobile === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^\d+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, mobile: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('email')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Email*</label>
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                id="email"
                                value={email}
                                placeholder=""
                                className={`inputbox ${validationStates.email === false ? 'error' : ''}`}
                                onBlur={() => validateInput('email', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'email' && (
                                <div className="hover-description">
                                    Current email.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Type of application</h2> <br></br>

                    <Row>
                        <Col>
                            <label>Type of application*</label> <br />
                            <select
                                id="applicationType"
                                value={applicationType}
                                onChange={(e) => handleApplicationTypeChange(e.target.value)}
                                className={`inputbox ${validationStates.applicationType === false ? 'error' : ''}`}
                                onBlur={() => validateInput('applicationType', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="Simple (single number)">
                                    Simple (single number)
                                </option>
                                <option value="Complex (MSN, DDI)">
                                    Complex (MSN, DDI)
                                </option>
                            </select>
                        </Col>
                    </Row>

                    <br></br>

                    {isSimple && (
                        <>
                            <h4 className='text-decoration-underline'>Required telephone number or a group number to be ported</h4> <br></br>

                            <h4 className='text-decoration-underline'>Single Number</h4> <br></br>

                            <Table striped bordered hover variant="light">
                                <thead>
                                    <tr>
                                        <th>Single Number*</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableDataSingle.map(row => (
                                        <tr key={row.id}>

                                            <td
                                                onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <input
                                                    type="text"
                                                    id={`number-${row.id}`}
                                                    value={row.num}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        handleChange_tableSingle(row.id, 'num', value);

                                                        if (value === '' || !/^\d+$/.test(value)) {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: true,
                                                            }));
                                                        }
                                                    }}
                                                    className={`inputbox ${validationStates[`number-${row.id}`] === false ? 'error' : ''}`}
                                                    onBlur={() => {
                                                        if (row.num === '') {
                                                            toast.error('Single Number is required.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: false,
                                                            }));
                                                        } else if (!/^\d+$/.test(row.num)) {
                                                            toast.error('Single Number must contain only digits.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`number-${row.id}`]: true,
                                                            }));
                                                        }
                                                    }}
                                                />

                                                {hoveredField === `number-${row.id}` && (
                                                    <div className="hover-description">
                                                        Add single numbers if any
                                                    </div>
                                                )}
                                            </td>

                                            <td>
                                                {tableDataSingle.length > 1 && (
                                                    <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <button onClick={addRow_single}>Add Row</button>
                        </>
                    )}

                    {isComplex && (
                        <>
                            <h4 className='text-decoration-underline'>Required telephone number or a group number to be ported</h4><br></br>

                            <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                            <Row>
                                <Col>
                                    <button
                                        variant="secondary"
                                        className="inputbox"
                                        style={{ alignItems: 'center' }}
                                        onClick={() => fileInputRef.current.click()}
                                    >
                                        <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                        Upload File
                                    </button>
                                    <input
                                        id="fileUploadInput"
                                        type="file"
                                        accept=".xlsx, .xls"
                                        onChange={handleFileUpload}
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                    />
                                </Col>

                                <Col>
                                    <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                        <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                        Download number range template
                                    </button>
                                </Col>

                                <Col>
                                    {uploadedFileName && (
                                        <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                            <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                            Remove
                                        </button>
                                    )}
                                </Col>

                            </Row>

                            <br />
                            <p>The template is the same used for the btd portability request.</p>
                            <br />

                            <Table striped bordered hover variant="light">
                                <thead>
                                    <tr>
                                        <th>Number range start*</th>
                                        <th>Number range end*</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {tableDataRange.map(row => (
                                        <tr key={row.id}>

                                            <td
                                                onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <input
                                                    type="text"
                                                    id={`startNumber-${row.id}`}
                                                    value={row.sNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        handleChange_tableRange(row.id, 'sNumber', value);

                                                        const isValid = /^\d+$/.test(value);
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`startNumber-${row.id}`]: isValid,
                                                        }));
                                                    }}
                                                    className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                                    onBlur={() => {
                                                        const isValid = /^\d+$/.test(row.sNumber);
                                                        if (!isValid) {
                                                            toast.error('Only numeric input allowed and cannot be empty.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`startNumber-${row.id}`]: false,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {hoveredField === `startNumber-${row.id}` && (
                                                    <div className="hover-description">
                                                        Number Range Start
                                                    </div>
                                                )}
                                                {validationStates[`startNumber-${row.id}`] === false && (
                                                    <div className="error-message">
                                                        Only numeric input allowed and cannot be empty.
                                                    </div>
                                                )}
                                            </td>

                                            <td
                                                onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <input
                                                    type="text"
                                                    id={`endNumber-${row.id}`}
                                                    value={row.eNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        handleChange_tableRange(row.id, 'eNumber', value);

                                                        const isValid = /^\d+$/.test(value);
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`endNumber-${row.id}`]: isValid,
                                                        }));
                                                    }}
                                                    className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                                    onBlur={() => {
                                                        const isValid = /^\d+$/.test(row.eNumber);
                                                        if (!isValid) {
                                                            toast.error('Only numeric input allowed and cannot be empty.');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`endNumber-${row.id}`]: false,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {hoveredField === `endNumber-${row.id}` && (
                                                    <div className="hover-description">
                                                        Number Range End
                                                    </div>
                                                )}
                                                {validationStates[`endNumber-${row.id}`] === false && (
                                                    <div className="error-message">
                                                        Only numeric input allowed and cannot be empty.
                                                    </div>
                                                )}
                                            </td>

                                            <td>
                                                {tableDataRange.length > 1 && (
                                                    <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                            <button onClick={addRow_range}>Add Row</button>

                        </>
                    )}

                    <br></br><br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('recipient')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Recipient*</label>
                            <input
                                onChange={(e) => setRecipient(e.target.value)}
                                type="text"
                                id="recipient"
                                value={recipient}
                                placeholder=""
                                className={`inputbox ${validationStates.recipient === false ? 'error' : ''}`}
                                onBlur={() => validateInput('recipient', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'recipient' && (
                                <div className="hover-description">
                                    Enter name/surname.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('donor')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Donor*</label>
                            <input
                                onChange={(e) => setDonor(e.target.value)}
                                type="text"
                                id="donor"
                                value={donor}
                                placeholder=""
                                className={`inputbox ${validationStates.donor === false ? 'error' : ''}`}
                                onBlur={() => validateInput('donor', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'donor' && (
                                <div className="hover-description">
                                    Doner name.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date of the porting process completion</label> <br />
                            <input
                                onChange={(e) => setDatePort(e.target.value)}
                                type="date"
                                id="datePort"
                                value={datePort}
                                className={`inputbox`}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <label>Date of the activation of services on the ported number in the Recipient's network</label> <br />
                            <input
                                onChange={(e) => setDateService(e.target.value)}
                                type="date"
                                id="dateService"
                                value={dateService}
                                className={`inputbox`}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <label>Number of the contract on connection assigned by the Donor*</label>
                            <input
                                onChange={(e) => setDonorNumber(e.target.value)}
                                type="text"
                                id="donorNumber"
                                value={donorNumber}
                                placeholder=""
                                className={`inputbox ${validationStates.donorNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('donorNumber', /^.*$/)}
                            />
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Applicant</h2> <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('place')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Place*</label>
                            <input
                                onChange={(e) => setPlace(e.target.value)}
                                type="text"
                                id="place"
                                value={place}
                                placeholder=""
                                className={`inputbox ${validationStates.place === false ? 'error' : ''}`}
                                onBlur={() => validateInput('place', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'place' && (
                                <div className="hover-description">
                                    Enter location.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('sign')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Signature and stamp of the applicant (or authorised person or legal guardian)*</label>
                            <input
                                onChange={(e) => setSign(e.target.value)}
                                type="text"
                                id="sign"
                                value={sign}
                                placeholder=""
                                className={`inputbox ${validationStates.sign === false ? 'error' : ''}`}
                                onBlur={() => validateInput('sign', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'sign' && (
                                <div className="hover-description">
                                    Enter signature.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                {/* <Container>

                    <h2 className='heading'>Recipient (to be filled in by Voxbone)</h2> <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('placeReci')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Place</label>
                            <input
                                onChange={(e) => setPlaceReci(e.target.value)}
                                type="text"
                                id="placeReci"
                                value={placeReci}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'placeReci' && (
                                <div className="hover-description">
                                    Enter location.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date of receiving the Application*</label> <br />
                            <input
                                onChange={(e) => setDateReci(e.target.value)}
                                type="date"
                                id="dateReci"
                                value={dateReci}
                                className={`inputbox ${validationStates.dateReci === false ? 'error' : ''}`}
                                onBlur={() => validateInput('dateReci', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('nameEmployee')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Name of employee</label>
                            <input
                                onChange={(e) => setNameEmployee(e.target.value)}
                                type="text"
                                id="nameEmployee"
                                value={nameEmployee}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'nameEmployee' && (
                                <div className="hover-description">
                                    Enter name/surname.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Signature and stamp of the Recipient</label>
                            <input
                                onChange={(e) => setSignReci(e.target.value)}
                                type="text"
                                id="signReci"
                                value={signReci}
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                </Container> */}

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Slovakia;